/* ==========================================================================
   Selvo — Premium Navbar Scroll Enhancement
   ========================================================================== */
(function () {
  const navbar = document.getElementById('navbar-wrapper');
  if (!navbar) return;
  function updateNavbar() {
    if (window.scrollY > 60) {
      navbar.classList.add('is-scrolled');
    } else {
      navbar.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', updateNavbar, { passive: true });
  updateNavbar();
})();

/* ==========================================================================
   Selvo — Scroll Reveal Animation
   Watches .selvo-reveal elements and adds .is-visible when in viewport
   ========================================================================== */
(function () {
  function initReveal() {
    const items = document.querySelectorAll('.selvo-reveal');
    if (!items.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
